import { TypedDocumentNode, gql } from '@apollo/client';

import { Variant } from 'components/rewards/RewardOverview/types';
import { useSo5RewardOrConfigSimpleRewards } from 'hooks/so5/useSo5RewardOrConfigSimpleRewards';

import { So5RankingRewards_so5Ranking } from './__generated__/index.graphql';

type Props = { so5Ranking: So5RankingRewards_so5Ranking; variant: Variant };

export const So5RankingRewards = ({ so5Ranking, variant }: Props) => {
  const { eligibleOrSo5Rewards, so5Lineup } = so5Ranking;

  const { clickableRewardsOverview } = useSo5RewardOrConfigSimpleRewards({
    so5RewardOrConfigs: eligibleOrSo5Rewards,
    rarity: so5Lineup.so5Leaderboard?.mainRarityType || null,
    so5League: so5Lineup.so5Leaderboard?.so5League,
    variant,
  });

  return clickableRewardsOverview;
};

So5RankingRewards.fragments = {
  so5Ranking: gql`
    fragment So5RankingRewards_so5Ranking on So5Ranking {
      id
      eligibleOrSo5Rewards {
        ...useSo5RewardOrConfigSimpleRewards_so5RewardOrConfig
      }
      so5Lineup {
        id
        so5Leaderboard {
          slug
          mainRarityType
          so5League {
            slug
            ...useSo5RewardOrConfigSimpleRewards_so5League
          }
        }
      }
    }
    ${useSo5RewardOrConfigSimpleRewards.fragments.so5RewardOrConfig}
    ${useSo5RewardOrConfigSimpleRewards.fragments.so5League}
  ` as TypedDocumentNode<So5RankingRewards_so5Ranking>,
};
